import { EXCLUDE_END_DATE_CATEGORIES } from '@nile/banyan/src/Pages/ServiceCatalog/constants';
import { EndDate } from '@nile/banyan/src/Pebbles/ServiceCatalog/catalogForm';
import {
  AppContext,
  DropdownIndicator,
  formatGroupLabel,
  getTranslatedText,
  IndicatorSeparator,
  Suffix,
  SuperPop
} from '@nile/components';
import {
  Checkbox,
  Dropdown,
  Label,
  TextField,
  Heading,
  Button,
  Spinner
} from '@superops/ui-design-system';
import { GET_PRORATED_AMOUNT, AccountClient } from '@nile/graphql';
import { useFlags } from 'launchdarkly-react-client-sdk';
import { useLazyQuery } from '@apollo/client';
import dompurify from 'dompurify';
import { Tooltip } from 'react-clone-tippy';
import { SVGIcon } from '@superops/super-icons';
import dayjs from 'dayjs';
import { includes } from 'lodash';
import React, { useContext, useState, useEffect } from 'react';
import DatePicker from 'react-datepicker';
import { FormattedMessage, injectIntl } from 'react-intl';
import styled from 'styled-components';
import ItemQuantity from './ItemQuantity';
import { dompurifier } from '@nile/components/src/Utils/helpers';
import { useCurrencySymbols } from '@nile/components';

const Field = styled.div`
  margin-top: 24px;
  width: 200px;
  .item-quantity {
    padding-left: 0 !important;
  }
  .react-datepicker__input-container > input {
    height: 38px;
    width: 200px;
  }
`;

const Operation = styled.div`
  background: ${(props) =>
    props.selected
      ? props.type === 'DECREASE'
        ? '#EC5151'
        : '#77BB61'
      : 'transprent'};
  transform: ${(props) =>
    props.type === 'DECREASE' ? 'rotate(0deg)' : 'rotate(180deg)'};
`;

function QuantityCollector(props) {
  const {
    change,
    handlePropChange,
    effectiveDate,
    billDate,
    nextBillDate,
    endDate,
    intl,
    currencyCode,
    countryCode,
    mode,
    subscriptionType,
    frequency,
    unitPrice,
    proratedAmount,
    getProratedAmount,
    loading,
    unitType,
    totalUsers,
    totalAssets,
    sectionType,
    dynamicType,
    quantityType,
    quantity,
    clientId,
    formType,
    amount,
    valueType,
    integrationAddOn,
    isSiteSpecificEnabled,
    subscriptionItemQuantityCount
  } = props;

  let effectiveNextBillDate = nextBillDate;

  if (frequency?.recurringMode === 'ADVANCE') {
    effectiveNextBillDate = dayjs(nextBillDate)
      .add(frequency?.recurringBefore, 'days')
      .format('YYYY-MM-DD');
  }

  const unitTypeMap = {
    ALL_USER: totalUsers,
    ASSET_VIEW: totalAssets
  };

  const flags = useFlags();
  const { currencySymbolWithCode } = useCurrencySymbols();

  function getProratedAmountFunc(addInputObj) {
    const inputObj = {
      itemInput: {
        quantityType: quantityType,
        billDate: billDate,
        effectiveDate: change?.effectiveDate,
        unitPrice: unitPrice,
        quantity: change?.quantity
          ? change?.quantity
          : unitType !== 'CUSTOM'
          ? isSiteSpecificEnabled || unitType !== 'ALL_USER'
            ? subscriptionItemQuantityCount
            : unitTypeMap[unitType]
          : undefined,
        amount: change?.amount ? change?.amount : undefined,
        // subscriptionType: subscriptionType,
        frequency: frequency,
        endDate: endDate || undefined,
        clientId: clientId,
        ...addInputObj
      }
    };
    getProratedAmount({
      variables: inputObj,
      input: inputObj
    });
  }

  useEffect(() => {
    if (
      (unitType && unitType !== 'CUSTOM') ||
      (change?.effectiveDate &&
        (change?.quantityChangeOperation === 'INCREASE' ||
          (change && !change?.hasOwnProperty('quantityChangeOperation')))) // initial quantity collector will not have change object
    ) {
      getProratedAmountFunc();
    }
  }, []);
  const validatedInputValue = (val) => {
    let updatedVal = val;
    try {
      if (updatedVal.includes('.')) {
        const splitData = updatedVal.split('.');
        splitData[1] = splitData[1].slice(0, 2);
        updatedVal = splitData.join('.');
        if (updatedVal?.length > 11) {
          updatedVal = val.slice(0, 11);
        }
      } else if (updatedVal?.length > 10) {
        updatedVal = val.slice(0, 10);
      }
      return updatedVal;
    } catch (err) {
      return val;
    }
  };

  const validatedInputValueForQuantity = (val) => {
    let updatedVal = val;
    updatedVal = updatedVal.replace('.', '');
    try {
      if (updatedVal?.length > 10) {
        updatedVal = val.slice(0, 10);
      }
      return updatedVal;
    } catch (err) {
      return val;
    }
  };

  const getQuantityTextField = () => {
    if (unitType && unitType !== 'CUSTOM') {
      return (
        <TextField
          disabled
          value={
            isSiteSpecificEnabled || unitType !== 'ALL_USER'
              ? subscriptionItemQuantityCount
              : unitTypeMap[unitType]
              ? String(unitTypeMap[unitType])
              : '0'
          }
          min={0}
          type="number"
        />
      );
    }
    if (sectionType === 'BLOCK') {
      switch (dynamicType) {
        case 'HOUR':
          return (
            <TextField
              value={
                formType === 'service-catalog' ||
                formType === 'contract-template'
                  ? quantity?.toString() || ''
                  : change?.quantity?.toString() || ''
              }
              min={0}
              type="number"
              onChange={(val) => {
                if (
                  formType === 'service-catalog' ||
                  formType === 'contract-template'
                ) {
                  const updatedVal = validatedInputValue(val);
                  handlePropChange('quantity', updatedVal);
                } else {
                  const updatedVal = validatedInputValue(val);
                  handlePropChange('change', {
                    ...change,
                    quantity: updatedVal || null
                  });
                }
              }}
              suffix={getTranslatedText(intl, 'admin.serviceCatalog.hours')}
              onBlur={() => {
                if (change?.effectiveDate && change?.quantity?.toString()) {
                  getProratedAmountFunc();
                }
              }}
            />
          );
        case 'MONEY':
          return (
            <TextField
              value={
                formType === 'service-catalog' ||
                formType === 'contract-template'
                  ? amount?.toString() || ''
                  : change?.amount?.toString() || ''
              }
              min={0}
              type="number"
              onChange={(val) => {
                if (
                  formType === 'service-catalog' ||
                  formType === 'contract-template'
                ) {
                  const updatedVal = validatedInputValue(val);
                  handlePropChange('amount', updatedVal);
                } else {
                  const updatedVal = validatedInputValue(val);
                  handlePropChange('change', {
                    ...change,
                    amount: updatedVal || null
                  });
                }
              }}
              onBlur={() => {
                if (change?.effectiveDate && change?.amount?.toString()) {
                  getProratedAmountFunc();
                }
              }}
              suffix={currencySymbolWithCode}
            />
          );
        default:
          return '';
      }
    }
    switch (mode) {
      case 'DEFAULT':
        return (
          <TextField
            value={
              formType === 'service-catalog' || formType === 'contract-template'
                ? quantity?.toString() || ''
                : change?.quantity
                ? String(change?.quantity)
                : null
            }
            // value={change?.quantity ? String(change?.quantity) : null}
            min={0}
            type="number"
            disabled={integrationAddOn}
            onChange={(val) => {
              if (
                formType === 'service-catalog' ||
                formType === 'contract-template'
              ) {
                let updatedVal = validatedInputValue(val);
                if (valueType === 'INTEGER') {
                  updatedVal = validatedInputValueForQuantity(val);
                }
                handlePropChange('quantity', updatedVal);
              } else {
                let updatedVal = validatedInputValue(val);
                if (valueType === 'INTEGER') {
                  updatedVal = validatedInputValueForQuantity(val);
                }
                handlePropChange('change', {
                  ...change,
                  quantity: updatedVal || null
                });
              }
            }}
            onBlur={() => {
              if (change?.effectiveDate) {
                getProratedAmountFunc();
              }
            }}
          />
        );
      default:
        return (
          <TextField
            value={change?.quantity ? String(change?.quantity) : null}
            min={0}
            type="number"
            onChange={(val) => {
              const updatedVal = validatedInputValueForQuantity(val);
              handlePropChange('change', { ...change, quantity: updatedVal });
            }}
            onBlur={() => {
              if (
                (change?.quantity || change?.amount) &&
                change?.effectiveDate &&
                (change?.quantityChangeOperation === 'INCREASE' ||
                  (change &&
                    !change?.hasOwnProperty('quantityChangeOperation')))
              ) {
                getProratedAmountFunc();
              }
            }}
            suffix={
              <div className="ptr bshadow flex rounder-4px h-25">
                <Operation
                  selected={change.quantityChangeOperation === 'INCREASE'}
                  onClick={() => {
                    handlePropChange('change', {
                      ...change,
                      quantityChangeOperation: 'INCREASE'
                    });
                    if (
                      (change?.quantity || change?.amount) &&
                      change?.effectiveDate &&
                      change?.quantityChangeOperation === 'INCREASE'
                    ) {
                      getProratedAmountFunc();
                    }
                  }}
                >
                  <SVGIcon
                    name="ArrowDown"
                    color={
                      change.quantityChangeOperation === 'INCREASE'
                        ? 'white'
                        : 'black'
                    }
                  />
                </Operation>
                {effectiveNextBillDate && (
                  <Operation
                    selected={change.quantityChangeOperation === 'DECREASE'}
                    type="DECREASE"
                    onClick={() => {
                      if (frequency.recurringMode === 'ARREAR') {
                        handlePropChange('change', {
                          ...change,
                          quantityChangeOperation: 'DECREASE'
                          // effectiveDate: dayjs(getDateRange(billDate).end).format(
                          //   'YYYY-MM-DD'
                          // )
                        });
                      } else {
                        handlePropChange('change', {
                          ...change,
                          quantityChangeOperation: 'DECREASE',
                          effectiveDate: dayjs(effectiveNextBillDate)
                            .subtract(1, 'day')
                            .format('YYYY-MM-DD')
                        });
                      }
                    }}
                  >
                    <SVGIcon
                      name="ArrowDown"
                      color={
                        change.quantityChangeOperation === 'DECREASE'
                          ? 'white'
                          : 'black'
                      }
                    />
                  </Operation>
                )}
              </div>
            }
          />
        );
    }
  };
  const getProratedSection = () => {
    return (
      <div className="flex actr p20 cosmic-latter border-radius-md">
        <div>
          <Label>
            <FormattedMessage id="client.contracts.item.proratedAmount" />
          </Label>

          <ProratedAmount
            {...props}
            amount={proratedAmount}
            loading={loading}
          />
        </div>
        <div className="ml-10">
          <Checkbox
            label={getTranslatedText(
              intl,
              'client.contracts.item.generateInvoice'
            )}
            checked={change?.generateInvoice}
            onChange={(val) => {
              handlePropChange('change', {
                ...change,
                generateInvoice: val
              });
            }}
          />
        </div>
        <div className="ml-20">
          <SuperPop
            position="top-start"
            content={getTranslatedText(
              intl,
              'client.contracts.item.generateInvoice.supertip'
            )}
          />
        </div>
      </div>
    );
  };

  // const getDdateRange = (eDate) => {
  //   const currentMonth = dayjs().get('month') + 1;
  //   const currentYear = dayjs().get('year');
  //   const currentDay = dayjs().get('date');
  //   const effectiveDateArr = eDate.split('-');
  //   const effectiveDateMonth = effectiveDateArr[1];
  //   const effectiveDateYear = effectiveDateArr[0];
  //   const effectiveDateDay = effectiveDateArr[2];
  //   let currentCycleDate = `${currentYear}-${effectiveDateMonth}-${effectiveDateDay}`;
  //   if (subscriptionType === 'YEAR') {
  //     currentCycleDate = `${currentYear}-${effectiveDateMonth}-${effectiveDateDay}`;
  //   }

  //   const dateTypeMap = {
  //     DAY: 'day',
  //     WEEK: 'week',
  //     MONTH: 'month',
  //     YEAR: 'year'
  //   };

  //   if (effectiveDateDay <= currentDay && effectiveDateMonth <= currentMonth) {
  //     return {
  //       start: dayjs(currentCycleDate).toDate(),
  //       end: dayjs(currentCycleDate)
  //         .add(frequency?.quantity || 1, dateTypeMap[subscriptionType])
  //         .subtract(1, 'day')
  //         .toDate()
  //     };
  //   }
  //   return {
  //     start: dayjs(currentCycleDate)
  //       .subtract(frequency?.quantity || 1, dateTypeMap[subscriptionType])
  //       .toDate(),
  //     end: dayjs(currentCycleDate)
  //       .subtract(1, 'day')
  //       .toDate()
  //   };
  // };

  const dateTypeMap = {
    DAY: 'day',
    WEEK: 'week',
    MONTH: 'month',
    YEAR: 'year'
  };

  const getNextBillingCycle = (startDate) => {
    const currentDate = dayjs(dayjs().toDate()).format('YYYY-MM-DD');

    const updatedStartDate = dayjs(startDate)
      .add(frequency?.quantity, dateTypeMap[subscriptionType])
      .toDate();
    const updatedEnddDate = dayjs(updatedStartDate)
      .add(frequency?.quantity, dateTypeMap[subscriptionType])
      .subtract(1, 'day')
      .toDate();

    if (currentDate <= dayjs(updatedEnddDate).format('YYYY-MM-DD')) {
      return {
        start: updatedStartDate,
        end: updatedEnddDate
      };
    }

    return getNextBillingCycle(updatedStartDate);
  };

  const getDateRange = (eDate) => {
    const currentMonth = dayjs().get('month') + 1;
    const currentYear = dayjs().get('year');
    const currentDay = dayjs().get('date');
    const effectiveDateArr = eDate.split('-');
    const effectiveDateMonth = effectiveDateArr[1];
    const effectiveDateYear = effectiveDateArr[0];
    const effectiveDateDay = effectiveDateArr[2];
    const currentDate = dayjs(dayjs().toDate()).format('YYYY-MM-DD');

    if (frequency?.recurringMode !== 'ARREAR' && eDate === currentDate) {
      const startDate = dayjs(eDate).toDate();
      const enddDate = dayjs(startDate)
        .add(frequency?.quantity, dateTypeMap[subscriptionType])
        .subtract(1, 'day')
        .toDate();

      if (currentDate <= dayjs(enddDate).format('YYYY-MM-DD')) {
        return {
          start: startDate,
          end: enddDate
        };
      }

      return getNextBillingCycle(startDate);
    }

    return {
      start: dayjs(
        `${effectiveDateYear}-${effectiveDateMonth}-${effectiveDateDay}`
      )
        .subtract(frequency?.quantity || 1, dateTypeMap[subscriptionType])
        .toDate(),
      end: dayjs(
        `${effectiveDateYear}-${effectiveDateMonth}-${effectiveDateDay}`
      )
        .subtract(1, 'day')
        .toDate()
    };
  };

  const getMaxEffectiveDate = () => {
    let maxEffectiveDate = null;

    if (effectiveNextBillDate) {
      maxEffectiveDate = getDateRange(effectiveNextBillDate).end;
    }

    if (
      endDate &&
      effectiveNextBillDate &&
      dayjs(getDateRange(endDate).end).isBefore(effectiveNextBillDate)
    ) {
      maxEffectiveDate = dayjs(endDate).toDate();
    }

    return maxEffectiveDate;
  };

  const quantityTextMap = {
    UNITS: 'client.contracts.queue.quantity',
    BLOCK_HOURS: 'client.contracts.queue.blockHours.quantity',
    BLOCK_MONEY: 'client.contracts.queue.blockMoney.quantity'
  };

  const changeQuantityTextMap = {
    UNITS: 'client.contracts.queue.changeInquantity',
    BLOCK_HOURS: 'client.contracts.queue.blockHours.quantity',
    BLOCK_MONEY: 'client.contracts.queue.blockMoney.quantity'
  };

  const allowedSubscriptionTypesArr = ['DAY', 'WEEK', 'MONTH', 'YEAR'];

  return (
    <div className="flex g20 mt-10">
      <Field>
        <Label>
          <FormattedMessage
            id={
              mode === 'DEFAULT'
                ? quantityTextMap[quantityType]
                : changeQuantityTextMap[quantityType]
            }
          />
        </Label>
        {getQuantityTextField()}
        {props?.errors && (
          <div className="mt8">
            <FormattedMessage id="client.contracts.item.quantity.validationMessage" />
          </div>
        )}
      </Field>
      {!integrationAddOn &&
        allowedSubscriptionTypesArr.includes(subscriptionType) &&
        formType !== 'service-catalog' &&
        formType !== 'contract-template' && (
          <Field>
            <div>
              <Label>
                <FormattedMessage id="client.contracts.item.effectiveDate" />
              </Label>

              {billDate ? (
                <DatePicker
                  minDate={
                    effectiveNextBillDate
                      ? getDateRange(effectiveNextBillDate).start
                      : null
                  }
                  maxDate={getMaxEffectiveDate()}
                  selected={
                    change?.effectiveDate &&
                    dayjs(change?.effectiveDate).toDate()
                  }
                  onChange={(date) => {
                    const formattedDate = date
                      ? dayjs(date).format('YYYY-MM-DD')
                      : null;
                    handlePropChange('change', {
                      ...change,
                      effectiveDate: formattedDate
                    });
                    if (
                      formattedDate &&
                      frequency.recurringMode !== 'ARREAR' &&
                      (unitType !== 'CUSTOM' ||
                        ((change?.quantity || change?.amount) &&
                          (change?.quantityChangeOperation === 'INCREASE' ||
                            (change &&
                              !change?.hasOwnProperty(
                                'quantityChangeOperation'
                              )))))
                    ) {
                      getProratedAmountFunc({ effectiveDate: formattedDate });
                    }
                  }}
                  placeholderText="YYYY-MM-DD"
                  dateFormat="yyyy-MM-dd"
                  title={getTranslatedText(
                    intl,
                    'client.contracts.item.effectiveDate'
                  )}
                  required
                  disabled={
                    frequency.recurringMode !== 'ARREAR' &&
                    change?.quantityChangeOperation === 'DECREASE'
                  }
                />
              ) : (
                <Tooltip
                  html={
                    <p
                      dangerouslySetInnerHTML={{
                        __html: dompurifier(
                          getTranslatedText(
                            intl,
                            'client.details.contract.effectiveDate.validationMessage'
                          )
                        )
                      }}
                    />
                  }
                  inertia
                  trigger="mouseenter"
                  animation="shift"
                  animateFill={false}
                  className="tooltip"
                >
                  <DatePicker
                    selected={
                      change?.effectiveDate &&
                      dayjs(change?.effectiveDate).toDate()
                    }
                    onChange={(date) => {
                      const formattedDate = dayjs(date).format('YYYY-MM-DD');
                      handlePropChange('change', {
                        ...change,
                        effectiveDate: formattedDate
                      });
                      if (
                        unitType !== 'CUSTOM' ||
                        (change?.quantity &&
                          change?.quantityChangeOperation === 'INCREASE')
                      ) {
                        getProratedAmountFunc({ effectiveDate: formattedDate });
                      }
                    }}
                    placeholderText="YYYY-MM-DD"
                    dateFormat="yyyy-MM-dd"
                    title={getTranslatedText(
                      intl,
                      'client.contracts.item.effectiveDate'
                    )}
                    required
                    disabled
                  />
                </Tooltip>
              )}
            </div>
          </Field>
        )}
      {!integrationAddOn &&
        formType !== 'service-catalog' &&
        formType !== 'contract-template' &&
        change?.quantityChangeOperation !== 'DECREASE' &&
        change?.effectiveDate &&
        allowedSubscriptionTypesArr.includes(subscriptionType) &&
        frequency.recurringMode !== 'ARREAR' &&
        getProratedSection()}
    </div>
  );
}

function ProratedAmount(props) {
  const { change, countryCode, currencyCode, amount, loading } = props;
  const { currencySymbolWithCode } = useCurrencySymbols();

  if (loading)
    return (
      <Spinner
        accessibilityLabel="Small spinner example"
        size="small"
        color="inkLightest"
      />
    );
  return (
    <TextField
      size="extrasmall"
      value={amount}
      min={0}
      type="number"
      disabled
      suffix={currencySymbolWithCode}
    />
  );
}

export default injectIntl(QuantityCollector);
